/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-12-10 14:31:32
 * @LastEditors: TangXihao
 * @LastEditTime: 2020-12-11 09:33:21
 */
import React, { Component } from 'react'
import { ConfigProvider, DatePicker, Radio, Button, Table, Pagination } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'; // 中文语言包；
import Axios from 'axios'

import './index.css'

class MyOrder extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedRowKeys: [], // 此处可配置默认选中列
            doingAccount: "2",
            doneAccount: "3",
            data: [],
            idDownload: false
        }
    }

    componentDidMount() {
        Axios.get('/data/orderList.json')
            .then(res => {
                console.log(res.data)
                this.setState({
                    data: res.data
                })
            })
    }

    onSelectChange = (selectedRowKeys) => {
        console.log('selectedRowKeys changed: ', selectedRowKeys)   // 选择的key值
        this.setState({ selectedRowKeys })
    }


    render() {
        const { doingAccount, doneAccount, selectedRowKeys, data } = this.state
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange
        }
        return (
            <ConfigProvider locale={zhCN}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ borderBottom: "1px solid #e4e9f1" }}>
                        <div style={{ height: "47px", display: "flex", alignItems: "center", marginLeft: "36px", width: "96px", borderBottom: "4px solid #0072e5" }}>
                            <div style={{ display: "flex", margin: "0 auto", color: "#0072e5", fontSize: "18px" }}>
                                我的订购
                        </div>
                        </div>
                    </div>

                    <div style={{ height: "52px", marginLeft: "36px", marginRight: "120px", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", height: "32px", minWidth: "405px" }}>
                            <input style={{ width: "325px", height: "32px", border: "1px solid #e4e9f1" }} placeholder="搜索产品" />
                            <button style={{ minWidth: "68px", height: "32px", marginLeft: "12px", background: "#0072e5", color: "#fff", border: "none" }}>
                                搜索
                            </button>
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", height: "32px" }}>
                            <div style={{ minWidth: "595px", height: "32px", background: "#fff", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>

                                <div style={{ minWidth: "182px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "32px" }}>
                                    <div style={{ width: "56px", height: "19px", lineHeight: "19px", fontSize: "14px", color: "#393939" }}>
                                        起始时间
                                    </div>
                                    <DatePicker locale={zhCN} bordered={false} className="order-date-picker" />
                                </div>
                                <div style={{ minWidth: "182px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "32px" }}>
                                    <div style={{ width: "56px", height: "19px", lineHeight: "19px", fontSize: "14px" }}>
                                        终止时间
                                    </div>
                                    <DatePicker bordered={false} className="order-date-picker" style={{ padding: "0", marginLeft: "5px", color: "#393939" }} />
                                </div>
                            </div>
                            <Radio.Group className="order-radio-group" defaultValue="all" onChange={(e) => { console.log(e.target.value) }}>
                                <Radio value={"all"}>全部</Radio>
                                <Radio value={"today"}>今天</Radio>
                                <Radio value={"week"}>一周</Radio>
                                <Radio value={"month"}>一月内</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    <div style={{ minWidth: "1286px", height: "32px", margin: "36px 120px 24px 36px", display: "flex", justifyContent: "space-between" }}>

                        <Button style={{ width: "88px", background: "#061178", color: "#fff", }} onClick={() => { alert("hello") }}>
                            批量下载
                        </Button>
                        <div style={{ minWidth: "214px", height: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ minWidth: "80px", color: "#0072e5", fontSize: "16px" }}>{`正在处理:${doingAccount}`}</div>
                            <div style={{ minWidth: "80px", color: "#393939", fontSize: "16px" }}>{`处理完成:${doneAccount}`}</div>
                        </div>
                    </div>

                    <div style={{ minWidth: "1286px", margin: "0 120px 0 36px" }}>
                        <Table
                            style={{ background: "#ff0" }}

                            rowSelection={rowSelection}
                            className="order-row-select"
                            dataSource={data.map((item, index) => {
                                item.key = `key-${index}`
                                return item
                            })}
                            pagination={false}
                        >
                            <Table.Column
                                className="order-name-classname"
                                title={
                                    <div style={{ color: "#393939", fontSize: "16px" }}>
                                        订单名称
                                </div>
                                }
                                dataIndex="ordername"
                                width="10px"
                                align="center"
                            />
                            <Table.Column
                                title={
                                    <div style={{ color: "#393939", fontSize: "16px" }}>
                                        订单创建时间
                                    </div>
                                }
                                dataIndex="orderTime"
                                width="150px"
                                align="center"
                            />
                            <Table.Column
                                title={<div style={{ color: "#393939", fontSize: "16px" }}>订单状态</div>}
                                dataIndex="orderStatus"
                                width="150px"
                                align="center"
                                render={(text, record) => {
                                    console.log(text)
                                    if (text === true) {
                                        return <div>推送已完成</div>
                                    } else {
                                        return <div>没有分配</div>
                                    }
                                }}
                            />
                            <Table.Column
                                title={<div style={{ color: "#393939", fontSize: "16px" }}>操作</div>}
                                dataIndex='editor-operation'
                                width="100px"
                                align="center"
                                render={(text, record) =>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Button style={{ background: "#0072e533", color: "#0072e5", fontSize: "14px", border: "none", marginRight: "40px" }}>
                                            详情
                                        </Button>
                                        {
                                            this.state.isDownload ?
                                                <Button
                                                    style={{ background: "#969696", color: "#fff", fontSize: "14px", border: "none" }}
                                                    onClick={() => { this.setState({ isDownload: false }) }}
                                                >
                                                    取消
                                                </Button>
                                                :
                                                <Button
                                                    style={{ background: "#0072e5", color: "#fff", fontSize: "14px", border: "none" }}
                                                    onClick={() => { this.setState({ isDownload: true }) }}
                                                >
                                                    下载
                                                </Button>
                                        }
                                    </div>
                                }
                            />
                        </Table>
                        {/* <Pagination
                            className="myorder-table-pagination"
                             defaultCurrent={1} 
                             total={50}
                         /> */}

                    </div>
                </div>
            </ConfigProvider>
        )
    }
}

export default MyOrder